import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const steps = [
  { number: 1, title: 'Motivo' },
  { number: 2, title: 'Soluzione' },
  { number: 3, title: 'Conferma' }
];

const RMAStepper = ({ currentStep }) => {
  return (
    <div className="w-full py-6 px-4 border-b border-border bg-secondary/30">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center flex-1">
              <div className="flex items-center gap-3">
                <div className={cn(
                  "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all",
                  currentStep > step.number 
                    ? "bg-primary text-white" 
                    : currentStep === step.number 
                      ? "bg-primary text-white ring-4 ring-primary/20"
                      : "bg-muted text-muted-foreground"
                )}>
                  {currentStep > step.number ? (
                    <Check className="w-4 h-4" />
                  ) : (
                    step.number
                  )}
                </div>
                <span className={cn(
                  "hidden sm:block text-sm font-medium transition-colors",
                  currentStep >= step.number ? "text-primary" : "text-muted-foreground"
                )}>
                  {step.title}
                </span>
              </div>
              {index < steps.length - 1 && (
                <div className={cn(
                  "flex-1 h-0.5 mx-4 transition-colors",
                  currentStep > step.number ? "bg-primary" : "bg-muted"
                )} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RMAStepper;
